import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./confirm-delete-modal.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./confirm-delete-modal.component.scss?ngResource";
import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { SharedConstants } from "../../../../../constants/shared.constants";
import { AppConfig } from "../../../../../../app.config";
let ConfirmDeleteModalComponent = class ConfirmDeleteModalComponent {
    activeModalService;
    label;
    branding = {
        themeMainColor: SharedConstants.DEFAULT_COLOR,
        themeMainDarkerColor: SharedConstants.DEFAULT_DARKER_COLOR,
        themeMainBackgroundColor: SharedConstants.DEFAULT_COLOR,
        themeMainBorderColor: SharedConstants.DEFAULT_COLOR,
        themeHeaderBorderColor: SharedConstants.DEFAULT_HEADER_BORDER_COLOR,
        themeActiveColor: SharedConstants.DEFAULT_ACTIVE_COLOR,
        themeActiveAlternateColor: SharedConstants.DEFAULT_ACTIVE_ALTERNATE_COLOR,
        themePrimaryButtonColor: SharedConstants.DEFAULT_PRIMARY_BUTTON_COLOR
    };
    dialogTitle;
    deleteConfirmationText;
    cancelBtnPlaceholder = SharedConstants.CANCEL_LABEL;
    deleteBtnPlaceholder = SharedConstants.DELETE_LABEL;
    constructor(activeModalService) {
        this.activeModalService = activeModalService;
        if (AppConfig.settings.projectSettings && AppConfig.settings.projectSettings.styling) {
            this.branding = AppConfig.settings.projectSettings.styling;
        }
    }
    ngOnInit() {
        this.dialogTitle = `Delete ${this.label}`;
        this.deleteConfirmationText = `Are you sure you want to delete the selected ${this.label}?`;
    }
    onBtnCancelClicked() {
        this.activeModalService.close();
    }
    onBtnDeleteClicked() {
        this.activeModalService.close(true);
    }
    static ctorParameters = () => [
        { type: NgbActiveModal }
    ];
    static propDecorators = {
        label: [{ type: Input }]
    };
};
ConfirmDeleteModalComponent = __decorate([
    Component({
        selector: "app-confirm-delete-modal",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ConfirmDeleteModalComponent);
export { ConfirmDeleteModalComponent };
